import script from "./receivingRecord.vue?vue&type=script&lang=ts&setup=true"
export * from "./receivingRecord.vue?vue&type=script&lang=ts&setup=true"

import "./receivingRecord.vue?vue&type=style&index=0&id=33c2675a&scoped=true&lang=less"
import "./receivingRecord.vue?vue&type=style&index=1&id=33c2675a&lang=less"

import exportComponent from "D:\\projectLy\\2025伟本\\weben-les-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33c2675a"]])

export default __exports__